import React, { useState } from 'react';

/**
 * Porte d'accès du dashboard.
 * Compare le SHA-256 du code saisi à VITE_DASHBOARD_PASSCODE_SHA256 (jamais le
 * code en clair dans le bundle). Si la variable n'est pas définie → accès libre
 * (dev). Note : protection d'accès UI ; la vraie défense des données est la RLS
 * Supabase (voir SECURITY.md).
 */
const EXPECTED = import.meta.env.VITE_DASHBOARD_PASSCODE_SHA256 as string | undefined;
const STORAGE_KEY = 'mc_auth_ok';

async function sha256Hex(s: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(s));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('');
}

export const Gate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [ok, setOk] = useState<boolean>(() => !EXPECTED || localStorage.getItem(STORAGE_KEY) === EXPECTED);
  const [code, setCode] = useState('');
  const [err, setErr] = useState(false);

  if (ok) return <>{children}</>;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const hash = await sha256Hex(code);
    if (hash === EXPECTED) {
      localStorage.setItem(STORAGE_KEY, hash);
      setOk(true);
    } else {
      setErr(true);
      setCode('');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-full bg-bg-base text-white gap-6">
      <div className="text-center">
        <div className="text-2xl font-bold tracking-widest" style={{ fontFamily: '"Press Start 2P", monospace' }}>MISSION CONTROL</div>
        <div className="text-sm text-gray-400 mt-3">Accès réservé</div>
      </div>
      <form onSubmit={submit} className="flex flex-col gap-3 w-64">
        <input
          type="password" autoFocus value={code}
          onChange={(e) => { setCode(e.target.value); setErr(false); }}
          placeholder="Code d'accès"
          className="px-4 py-3 rounded-lg bg-gray-900 border border-gray-700 outline-none focus:border-emerald-500 text-center tracking-widest"
        />
        <button type="submit" className="px-4 py-3 rounded-lg bg-emerald-600 hover:bg-emerald-500 font-semibold transition-colors">
          Entrer
        </button>
        {err && <div className="text-red-400 text-sm text-center">Code incorrect</div>}
      </form>
    </div>
  );
};
